<template>
  <v-flex xs12>
    <v-card color="teal lighten-2" class="white--text">
      <v-layout>
        <v-flex xs6>
          <v-card-title primary-title>
            <div>
              <div class="headline">{{title}}</div>
            </div>
          </v-card-title>
        </v-flex>
        <v-flex class="pa-2" xs6>
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="saved*100/total"
            color="blue darken-4"
          >{{ ~~(saved*100/total) }} %</v-progress-circular>
        </v-flex>
      </v-layout>
      <v-divider light></v-divider>
      <v-card-actions class="pa-3">
        <v-btn @click="risparmia" flat dark>Metti da parte {{ step }}.- CHF!</v-btn>
        <v-spacer></v-spacer>
        <SettingDialog 
          :title="title"
          :id="id"
          :step="step"
          :saved="saved"
          :total="total"/>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import SettingDialog from "@/components/SettingDialog.vue";
export default {
  data: () => ({}),
  components: { SettingDialog },
  props: {
    id: String,
    title: String,
    step: Number,
    saved: Number,
    total: Number
  },
  methods: {
    risparmia: function() {
      this.$store.dispatch("risparmia", { id: this.id });
    }
  }
};
</script>

<style>
</style>
